import { Helper } from '../Helper';
export class ArrConcatHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitSysCall(node, 'Neo.Enumerator.Create');
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'TUCK');
                sb.emitSysCall(node, 'Neo.Enumerator.Next');
            },
            each: () => {
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'OVER');
                sb.emitSysCall(node, 'Neo.Enumerator.Value');
                sb.emitOp(node, 'APPEND');
            },
            cleanup: () => {
                sb.emitOp(node, 'NIP');
            },
        }));
    }
}

//# sourceMappingURL=ArrConcatHelper.js.map
